export const EXSBITEMTYPE_CREATE_RESET = 'EXSBITEMTYPE_CREATE_RESET'
export const EXSBITEMTYPE_CREATE_SET_CREATED = 'EXSBITEMTYPE_CREATE_SET_CREATED'
export const EXSBITEMTYPE_CREATE_SET_ERROR = 'EXSBITEMTYPE_CREATE_SET_ERROR'
export const EXSBITEMTYPE_CREATE_SET_VIOLATIONS = 'EXSBITEMTYPE_CREATE_SET_VIOLATIONS'
export const EXSBITEMTYPE_CREATE_TOGGLE_LOADING = 'EXSBITEMTYPE_CREATE_TOGGLE_LOADING'
